// this for old games to be able to  use new api with c and y operands. 
// gql returns c: null and y : null for old games messing up with tile and slider comparison.

import { OPERAND_TYPE } from "../../constants/constants";

// will only add to Operand string if c and y are defined.
export const buildOperandString = ({ a, x, b, c, y }: OPERAND_TYPE): string => {
  return [a, x, b]
    .concat(c !== undefined && c !== null ? [c] : [])
    .concat(y !== undefined && y !== null ? [y] : [])
    .join('_');
};

// will add c and y are null if they are undefined.
// this is to make sure that old games can use new api without issues.
export function addCAndYIfUndefined(obj: OPERAND_TYPE): OPERAND_TYPE {
  const updated = { ...obj };

  if (updated.c === undefined) {
    updated.c = null;
  }
  if (updated.y === undefined) {
    updated.y = null;
  }

  return updated;
}
